(() => {
	angular
		.module('main')
		.controller('CompanyInformationController', CompanyInformationController);

	CompanyInformationController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'$filter',
		'messageService',
		'accountService',
		'companySettingsService'
	];

	function CompanyInformationController(
		$scope,
		$rootScope,
		$location,
		$http,
		$filter,
		messageService,
		accountService,
		companySettingsService
	) {
		let removePressed, removeBanner;

		const request = {
			getEditableCompany($location, $rootScope, $scope) {
				delete $rootScope.error;
				$http({
					method: 'GET',
					url: '/protected/rest/company',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(
					result => {
						if (result && result.data) {
							$scope.timezoneList = $filter('timezoneFilter')(
								result.data.timeZones
							);
							$scope.company = result.data.company;
							$scope.gdprEnabledCheck = $scope.company.gdprEnabled;
							delete $scope.newCompanyImage;
							delete $scope.newCompanyBanner;

							if ($rootScope.user) {
								delete $rootScope.user.companyImage;
								delete $scope.newCompanyImage;
								delete $rootScope.user.companyBanner;
								delete $scope.newCompanyBanner;
								$rootScope.user.companyImage = result.data.company.image;
								$rootScope.user.companyBanner = result.data.company.banner;
							}
							$scope.companyName = result.data.company.name;
						} else {
							console.log('No company data');
						}

						$scope.$evalAsync();
					},
					data => {
						$rootScope.error_message = 'Failed request to server';
					}
				);
			}
		};

		$scope.$on('$viewContentLoaded', () => {
			removePressed = false;
			removeBanner = false;
			$scope.isSaveInfoSpinnningWheelActive = false;
			getUser();
			initDropzone();
		});

		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		$scope.clearFile = function() {
			removePressed = true;
			delete $scope.company.image;
		};

		$scope.removeCompanyBanner = function() {
			removeBanner = true;
			delete $scope.company.banner;
		};

		$scope.redirect = function(path) {
			$location.path(path);
		};

		$scope.saveCompanyData = function() {
			if ($scope.company.name !== undefined) {
				$scope.isSaveInfoSpinnningWheelActive = true;
				delete $rootScope.error;
				if (
					$scope.company.gdprEnabled === false &&
					$scope.gdprEnabledCheck === true
				) {
					$('#modalGdprWeb').modal('show');
				} else {
					continueToSaveData();
				}
			} else {
				messageService.showToaster('e_6', 'companyUsers');
			}
		};

		function continueToSaveData() {
			const formData = getData2Save();
			delete $scope.userActionResult;
			$scope.button_disable = true;
			removePressed = false;
			removeBanner = false;
			companySettingsService
				.editCompany(formData)
				.subscribe(
					data => companyEditSuccessCallback(data),
					error => companyEditErrorCallback(error)
				);
		}

		$scope.disableGdpr = function() {
			$scope.company.gdprEnabled = false;
			continueToSaveData();
			$('#modalGdprWeb').modal('hide');
		};
		$scope.cancelModal = function() {
			$scope.company.gdprEnabled = true;
			continueToSaveData();
		};

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
					}
				}
			);
		}

		function initDropzone() {
			$('#myAwesomeDropzone').dropzone({
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				method: 'GET',
				resize(file) {
					const resizeInfo = {
						srcX: 0,
						srcY: 0,
						trgX: 0,
						trgY: 0,
						srcWidth: file.width,
						srcHeight: file.height,
						trgWidth:
							file.width > file.height
								? file.width
								: file.width * (file.height / 300),
						trgHeight:
							file.width > file.height
								? file.height
								: file.height * (file.width / 300)
					};

					return resizeInfo;
				},
				addRemoveLinks: true,
				init() {
					this.on('addedfile', function(file) {
						if (this.files[1] != null) {
							this.removeFile(this.files[0]);
						}

						const MAX_SIZE = 2000; // 2MB MAX file size
						console.log('File added');

						if (file.size > MAX_SIZE * 1024) {
							this.removeFile(this.files[0]);
							file.previewElement = null;

							// toastr.error("The file you're attaching is bigger than the 2 Mb.");
							messageService.showToaster('e_1', 'companyInformation');
						}

						if (file.type != 'image/png' && file.type != 'image/jpeg') {
							this.removeFile(this.files[0]);
							file.previewElement = null;

							// toastr.error("Wrong file format! Please select jpg or png.");
							messageService.showToaster('e_0', 'companyInformation');
						}
						removePressed = false;

						$scope.newCompanyImage = file;
						$scope.newCompanyImageDnD = this;

						console.log('File src', file);
						$scope.$evalAsync();
					});

					$('#update').on('click', () => {
						// $scope.newCompanyImage = $scope.newCompanyImage;
					});

					const myDropZone = this;

					$('#btnRemoveAll').click(() => {
						if (myDropZone.files) {
							if (myDropZone.files[0]) {
								myDropZone.removeFile(myDropZone.files[0]);
							}
						}
					});
				}
			});

			$('#companyBannerDropzone').dropzone({
				thumbnailWidth: 300,
				thumbnailHeight: 300,
				method: 'GET',
				resize(file) {
					const resizeInfo = {
						srcX: 0,
						srcY: 0,
						trgX: 0,
						trgY: 0,
						srcWidth: file.width,
						srcHeight: file.height,
						trgWidth:
							file.width > file.height
								? file.width
								: file.width * (file.height / 300),
						trgHeight:
							file.width > file.height
								? file.height
								: file.height * (file.width / 300)
					};

					return resizeInfo;
				},
				addRemoveLinks: true,
				init() {
					this.on('addedfile', function(file) {
						if (this.files[1] != null) {
							this.removeFile(this.files[0]);
						}

						console.log('File added');
						const MAX_SIZE = 5000; // 5MB MAX file size

						if (file.size > MAX_SIZE * 1024) {
							this.removeFile(this.files[0]);
							file.previewElement = null;

							messageService.showToaster('e_2', 'companyInformation');
						}

						if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
							this.removeFile(this.files[0]);
							file.previewElement = null;
							messageService.showToaster('e_0', 'companyInformation');
						}
						removeBanner = false;

						$scope.newCompanyBanner = file;
						$scope.newCompanyBannerDnD = this;

						console.log('File src', file);
						$scope.$evalAsync();
					});

					const myDropZone = this;

					$('#removeCompanyBanner').click(() => {
						if (myDropZone.files) {
							if (myDropZone.files[0]) {
								myDropZone.removeFile(myDropZone.files[0]);
							}
						}
					});
				}
			});

			request.getEditableCompany($location, $rootScope, $scope);
		}

		$scope.updateCompanyLogo = function() {
			$('#myAwesomeDropzone').click();
		};

		$scope.updateCompanyBanner = function() {
			$('#companyBannerDropzone').click();
		};

		$scope.onEnableGdpr = function(isGdprEnabled) {
			$scope.company.gdprEnabled = isGdprEnabled;
		};

		function getData2Save() {
			const formData = new FormData();

			const fieldsToSave = [
				'name',
				'number',
				'address',
				'city',
				'state',
				'postcode',
				'country',
				'phone',
				'email',
				'timezone',
				'gdprEnabled'
			];

			for (const [key, value] of Object.entries($scope.company)) {
				const isFieldToSave = fieldsToSave.some(keyToSave => key === keyToSave);

				if (isFieldToSave) {
					if (key === 'timezone' && value.key) {
						formData.append(key, value.key);
					} else {
						formData.append(key, value === null ? '' : value);
					}
				}
			}

			formData.append('deleteImage', removePressed);
			if (removePressed) {
				$scope.newCompanyImage = null;
			}
			if ($scope.newCompanyImage) {
				formData.append('file', $scope.newCompanyImage);
			}

			formData.append('deleteBanner', removeBanner);
			if (removeBanner) {
				$scope.newCompanyBanner = null;
			}
			if ($scope.newCompanyBanner) {
				formData.append('banner', $scope.newCompanyBanner);
			}

			return formData;
		}

		function companyEditSuccessCallback(data) {
			$scope.button_disable = false;
			removePressed = false;
			removeBanner = false;
			messageService.showToaster('s_0', 'companyInformation');
			accountService.getUserWeb().subscribe(user => {
				if (user !== null && typeof user !== 'undefined') {
					$scope.user = JSON.parse(JSON.stringify(user));
				}
			});
			$scope.user.companyImage = null;
			$scope.companyName = data.name;
			$scope.company = data;
			$('#removeCompanyBanner').click();
			$('#btnRemoveAll').click();

			request.getEditableCompany($location, $rootScope, $scope);
			$scope.isSaveInfoSpinnningWheelActive = false;
		}

		function companyEditErrorCallback(error) {
			const { errorMessage, errorTitle } = error.error;

			if (
				errorTitle &&
				errorTitle !== null &&
				errorMessage &&
				errorMessage !== null
			) {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
			} else {
				messageService.showErrorFromBackend('Whoops!');
			}
			$scope.button_disable = false;
			$scope.isSaveInfoSpinnningWheelActive = false;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/companyInformationController.js